import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import loginReducer from "./loginReducer";

const configureStore = () => {
  return {
    ...createStore(loginReducer, composeWithDevTools(applyMiddleware(thunk)))
  };
};

export default configureStore;
